import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {useUser} from '@deezer/react-user';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useAuthLink} from '@app/hooks/use-link';

export const SongcatcherMore: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	const {getRegistrationLink} = useAuthLink();

	const [user] = useUser();
	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t('songcatcherlandingpage_title_humsingandmore_standalone-web', {
							ns: 'songcatcher',
						})}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('songcatcherlandingpage_text_humsingandmore_standalone-web', {
							ns: 'songcatcher',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '350px', md: '100%'}}
					sizes={{base: '100vw', md: '50vw'}}
					src="1a477d89c9ecf4160b99fa9ef1bc9b93.jpg"
					aspectRatio="2048/1661"
					alt={t('metatag_text_identifysongsbysinging_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'signup'}}
					href={
						user?.isConnected()
							? getDeezerUrl('/open_app')
							: getRegistrationLink()
					}
				>
					{t('generic_action_tryitnowfeature_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
